<h2 mat-dialog-title>

    {{
    data.ersetzen
    ? 'QR-Code ersetzen'
    : 'QR-Code vergeben'
    }}

</h2>


<mat-dialog-content>

    <p>

        {{
        data.ersetzen

        ? 'Scanne den neuen QR-Code, der den bisherigen Sticker ersetzen soll.'

        : 'Scanne den QR-Code, den du auf diese Messstelle geklebt hast.'
        }}

    </p>


    <video #video autoplay muted playsinline>
    </video>


    <div class="status" *ngIf="saving">

        QR-Code wird überprüft...

    </div>


    <div class="fehler" *ngIf="fehler">

        {{ fehler }}

        <div>
            <button mat-stroked-button type="button" (click)="erneutScannen()">

                Erneut scannen

            </button>
        </div>

    </div>

</mat-dialog-content>


<mat-dialog-actions align="end">

    <button mat-button type="button" (click)="schliessen()">

        Abbrechen

    </button>

</mat-dialog-actions>